import { render, staticRenderFns } from "./ViewDepartmentLogPopUp.vue?vue&type=template&id=e4ba6f00&scoped=true&"
import script from "./ViewDepartmentLogPopUp.vue?vue&type=script&lang=js&"
export * from "./ViewDepartmentLogPopUp.vue?vue&type=script&lang=js&"
import style0 from "./ViewDepartmentLogPopUp.vue?vue&type=style&index=0&id=e4ba6f00&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4ba6f00",
  null
  
)

export default component.exports